// extracted by mini-css-extract-plugin
export var _extraSmall = "TemplateSingleItem-module--_extraSmall--81abe";
export var _huge = "TemplateSingleItem-module--_huge--f18a0";
export var _inline = "TemplateSingleItem-module--_inline--11c7c";
export var _smallText = "TemplateSingleItem-module--_smallText--77232";
export var _verticalWithArrow = "TemplateSingleItem-module--_verticalWithArrow--da9bd";
export var aquamarine = "TemplateSingleItem-module--aquamarine--5b23c";
export var blue = "TemplateSingleItem-module--blue--561d3";
export var carrot = "TemplateSingleItem-module--carrot--538b1";
export var darkBlue = "TemplateSingleItem-module--darkBlue--a5063";
export var darkGray = "TemplateSingleItem-module--darkGray--28b2e";
export var gray = "TemplateSingleItem-module--gray--60e51";
export var green = "TemplateSingleItem-module--green--88b09";
export var lightBlue = "TemplateSingleItem-module--lightBlue--b2315";
export var lightGreen = "TemplateSingleItem-module--lightGreen--f5ef6";
export var magenta = "TemplateSingleItem-module--magenta--9cfda";
export var menuItem = "TemplateSingleItem-module--menuItem--7df3f";
export var pine = "TemplateSingleItem-module--pine--5c53e";
export var plum = "TemplateSingleItem-module--plum--9dfc4";
export var singleTemplateItem = "TemplateSingleItem-module--singleTemplateItem--55545";
export var templateIconWrap = "TemplateSingleItem-module--templateIconWrap--5db90";
export var templateItemSquare = "TemplateSingleItem-module--templateItemSquare--cce7a";
export var templateItemSquareIcon = "TemplateSingleItem-module--templateItemSquareIcon--c6256";
export var templateNameHidden = "TemplateSingleItem-module--templateNameHidden--3d855";
export var templateNameWrap = "TemplateSingleItem-module--templateNameWrap--fef76";
export var violet = "TemplateSingleItem-module--violet--6cb9e";
export var white = "TemplateSingleItem-module--white--07740";
export var yellow = "TemplateSingleItem-module--yellow--9fd47";